/** Params that are data-only: available via window globals / cookies,
 *  so we strip them from the URL instead of injecting and re-stripping. */
const DATA_ONLY_PARAMS = [
  "vb",
  "country",
  "currency",
  // "nuclick" is intentionally not listed here: NuClickBeacon owns its
  // removal after GTM has had a chance to read it on the initial page_view.
  // applyRebuiltSearch only refuses to re-add it once it is gone (INC-844).
]

/**
 * Applies the server-rebuilt search string to the current URL and returns
 * the relative URL to feed into history.replaceState.
 *
 * The beacon data is a snapshot of the landing request, but the stamping
 * effect re-runs on every SPA navigation. `nuclick` marks an ad-click
 * session entry, and NuClickBeacon removes it after GTM reads it, so the
 * stale snapshot must never stamp it back: it is kept only when the live
 * URL still has it (INC-844).
 *
 * @param currentHref The live window.location.href
 * @param rebuiltSearch The server-rebuilt search string from the beacon data
 * @returns The pathname + search + hash to pass to history.replaceState
 */
const applyRebuiltSearch = (
  currentHref: string,
  rebuiltSearch: string
): string => {
  const url = new URL(currentHref)
  const hadNuclick = url.searchParams.has("nuclick")

  url.search = rebuiltSearch
  for (const param of DATA_ONLY_PARAMS) {
    url.searchParams.delete(param)
  }
  if (!hadNuclick) {
    url.searchParams.delete("nuclick")
  }

  return url.pathname + url.search + url.hash
}

export { applyRebuiltSearch }
